import { ReleasePageFormDataWithName } from '@features/Funnel/screens/FunnelPage/ReleasePage/ReleasePageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { releasePayloadFactory } from '../../utils/releaseFunnelsPageFactory';

export function useTryToRequestCreatingReleaseFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (payload: ReleasePageFormDataWithName) => {
      const factory = await releasePayloadFactory(payload);
      const response =
        await apiCancellationFunnels.tryToRequestCreatingRelease(factory);
      return response;
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao crir o funil de Lançamento',
        'Ocorreu um erro ao criar o funil de Lançamento, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestCreatingReleaseFunnelPage: mutateAsync,
    isLoadingCreatingRelease: isPending,
  };
}
